<template>
  <div id="AddEnrollContact" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回活動小組長列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
          <tr class="table-success" align="left">



            <td>
              <div>
                <span class="red_star">＊</span>姓名:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.name"

                  placeholder="請輸入姓名"
                />
              </div>
            </td>

            <td>
              <div>
                <span class="red_star">＊</span>手機電話:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.cellPhone"
                  placeholder="請輸入手機電話"
                />
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddEnrollContact()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
//import Vue from 'vue';
import * as tools from "../tool";

export default {
  name: "AddEnrollContact",

  data() {
    return {
      mode: true,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,

      linkText: null,
      total: 0,
      isIE: false,

      inputData: {
        name:null,
        cellPhone:'',

      },
      currentPage: 1,
      cid: "",
      pageSize: 10,

    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {

    checkInput() {
      this.inputFlag = false;


      if (tools.empty(this.inputData.name)) {
        alert("請輸入姓名");
        this.inputFlag = true;
        return;
      }


      if (!tools.isValidPhoneNumber(this.inputData.cellPhone)) {
        alert("請輸入手機電話");
        this.inputData.cellPhone="";
        this.inputFlag = true;
        return;
      }

    },
    AddEnrollContact() {
      this.checkInput();
      let vm = this;
      if (vm.inputFlag != true) {
        this.$http
          .put("./WebApi/HighSchoolEnrolling/AddEnrollContact/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "增加活動小組長成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加活動小組長失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },


    close() {
      this.$emit("hideModal");
    },
  },
  mounted() {
    console.log("======created AddEnrollContactView =====");


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
